import { Typography, Box, Link } from '@mui/material'
import React, { FunctionComponent, useState } from 'react'
import { FooterLinks } from '../../config'
import { FooterLayoutBox } from '../box'
import { ILinkReplacerProps } from '../../interfaces/props'
import TnCDialog from '../tncDialog/TnCDialog'

const LinkReplacer = ({ label, link }: ILinkReplacerProps) => {
  return (
    <Link
      sx={{
        color: 'common.white',
        typography: { md: 'body1', sm: 'body1', xs: 'body1small' },
        display: 'inline-block',
        whiteSpace: 'nowrap',
        '&:hover': {
          color: '#7BBF6A', // light green hover color
        },
        '&:focus-visible': {
          outline: 'none',
          border: '2px solid #fff',
          borderRadius: '4px',
        },
      }}
      target='_blank'
      href={link}
      underline='hover'
      rel='noopener noreferrer'
      aria-label={`Open ${label} in a new tab`}
    >
      {label}
    </Link>
  )
}

export const I3Footer: FunctionComponent = () => {
  const [openTnC, setOpenTnC] = useState(false)
  const openTnCDialog = () => setOpenTnC(true)
  const closeTnCDialog = () => setOpenTnC(false)

  return (
    <FooterLayoutBox>
      <Box
        sx={{
          display: 'flex',
          gap: { xs: 0.5, sm: 2 },
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          gridColumn: '1 / -1',
          flexWrap: 'wrap',
          overflow: 'hidden',
          whiteSpace: 'normal',
          pr: { xs: 1, sm: 2 },
          px: { xs: 1, sm: 0 },
        }}
      >
        <LinkReplacer
          link={import.meta.env.REACT_APP_PrivacyPolicy}
          label={FooterLinks.privacyPolicy}
        />
        <Typography
          sx={{
            fontSize: { md: '1rem', sm: '0.95rem', xs: '0.68rem' },
            whiteSpace: 'nowrap',
          }}
        >
          {'|'}
        </Typography>
        <LinkReplacer
          link={import.meta.env.REACT_APP_i3Verticals}
          label={FooterLinks.companyName}
        />
        <Typography
          sx={{
            fontSize: { md: '1rem', sm: '0.95rem', xs: '0.68rem' },
            whiteSpace: 'nowrap',
          }}
        >
          {'|'}
        </Typography>
        <Link
          sx={{
            typography: { md: 'body1', sm: 'body1', xs: 'body1small' },
            whiteSpace: 'nowrap',
            display: 'inline-block',
            color: 'common.white',
            cursor: 'pointer',
            '&:hover': {
              color: '#7BBF6A', // light green hover color
            },
            '&:focus-visible': {
              outline: 'none',
              border: '2px solid #fff',
              borderRadius: '4px',
            },
          }}
          href='#'
          onClick={(e) => {
            e.preventDefault()
            openTnCDialog()
          }}
          aria-label={`Open ${FooterLinks.termsAndConditions} dialog`}
          underline='hover'
        >
          {FooterLinks.termsAndConditions}
        </Link>
      </Box>

      <TnCDialog open={openTnC} onClose={closeTnCDialog} />
    </FooterLayoutBox>
  )
}
